module.exports = __webpack_public_path__ + "img/sol_cap1.8fa0a5a0.png";